module.exports = "/static/assets/68c532d1295ba8ee1af5e2ce8148422d.png";